module.exports = __webpack_public_path__ + "img/icon_pdd.e8701e4e.png";